import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"font-weight":"500"} }

import { carcassStore } from '@/stores/v2/carcass'
import WoononProductMobile from '@/components/v2/WoononProductMobile.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'WoononCarcassProductsMobile',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createBlock(_component_a_collapse, { class: "carcass-collapse" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carcassStore)().groupedElements, (groupedElement, index) => {
        return (_openBlock(), _createBlock(_component_a_collapse_panel, {
          class: "modular-collapse-panel",
          key: index
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(groupedElement.commercial_name), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              gutter: [16,16],
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, {
                      gutter: [16,16],
                      class: "no-mb"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedElement.elements, (element) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: element.id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.products, (product) => {
                              return (_openBlock(), _createBlock(_component_a_col, {
                                span: 24,
                                key: product.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(WoononProductMobile, {
                                    store: _unref(carcassStore)(),
                                    product: product,
                                    isConfigurable: element.is_configurable_by_customer
                                  }, null, 8, ["store", "product", "isConfigurable"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})